import { z } from "zod";

export const ParameterElasticId_Schema = z.number(); // can be negative!
export const ParameterValueId_Schema = z.number(); // can be negative!

export const ParameterElastic_Schema = z.object({
  id: ParameterElasticId_Schema,
  name: z.string(),

  valueId: ParameterValueId_Schema,
  value: z.string().nullable(),

  // there are also other properties (valueInt, valueBool, ...), but they are not used
});

export type ParameterElasticId = z.infer<typeof ParameterElasticId_Schema>;
export type ParameterValueId = z.infer<typeof ParameterValueId_Schema>;
export type ParameterElastic = z.infer<typeof ParameterElastic_Schema>;
